import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mantine/core';

import { mediaQueryTablet } from '~/styles/mixins';

import { ParagraphMedium, TitleSmall } from '../typography';

const Flex = styled(Box)`
  display: flex;
`;

const Root = styled(Flex)`
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 0;
  background-color: #f3f9ff;
  border-radius: 8px;
`;

const CardImgContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: -102px;
  > img {
    max-width: 100%;
    max-height: 204px;
  }
  ${mediaQueryTablet} {
    margin-bottom: -40px;
    > img {
      max-width: 100%;
      max-height: 163px;
    }
  }
`;

const HowCard = ({ tag, title, text, img }) => {
  return (
    <Root>
      <>
        <TitleSmall color="#0c7beb">{tag}</TitleSmall>
        <TitleSmall color="#222222" mt="8px">
          {title}
        </TitleSmall>
        <ParagraphMedium color="#434343">{text}</ParagraphMedium>
      </>
      <CardImgContainer>
        <img src={img} alt="illustration" />
      </CardImgContainer>
    </Root>
  );
};

export default HowCard;
